// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Map route: same light sky gradient as home / profile (no global body theming) */
.mapshow {
  min-height: 100dvh;
  min-height: 100vh;
  box-sizing: border-box;
  background: linear-gradient(210deg, #c5dff7 0%, #eef2f7 52%, #f4f7fa 100%);
  color: #1c2d38;
  /* Same offset token as landing/profile for content below fixed nav */
  --navbar-offset: max(
    7.25rem,
    calc(
      max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem
    )
  );
}

.mapshow-inner {
  /* No top/side inset — nav is full-bleed fixed like landing */
  padding: 0 0 max(0.65rem, env(safe-area-inset-bottom, 0px));
  box-sizing: border-box;
  min-height: 100%;
}

/* Push map + leftbar below fixed navbar */
.mapshow .map-layout {
  padding-top: var(--navbar-offset);
  box-sizing: border-box;
}

/* Map area: must match fixed .leftbar width (min(400px, 100vw)) so the map is not covered */
.mapshow .map-layout__map-host {
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  margin-top: 0;
  margin-right: max(0.75rem, env(safe-area-inset-right, 0px));
  margin-bottom: max(0.65rem, env(safe-area-inset-bottom, 0px));
  margin-left: max(0.75rem, env(safe-area-inset-left, 0px));
  width: calc(100vw - max(0.75rem, env(safe-area-inset-left, 0px)) - max(0.75rem, env(safe-area-inset-right, 0px)));
  height: calc(100vh - var(--navbar-offset) - 1rem);
  max-height: calc(100dvh - var(--navbar-offset) - 1rem);
}

.mapshow .map-layout--with-sidebar .map-layout__map-host {
  --sidebar-w: min(400px, 100vw);
  --map-gap: 0.5rem;
  margin-left: calc(var(--sidebar-w) + var(--map-gap));
  /* Map starts after sidebar + gap; only subtract right inset/margin */
  width: clamp(
    12rem,
    calc(
      100vw - var(--sidebar-w) - var(--map-gap) -
        max(0.75rem, env(safe-area-inset-right, 0px))
    ),
    100vw
  );
}

/* Map navbar — fixed top bar, match landing div.navbar behavior */
.mapshow .navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  z-index: 1000;
  border-radius: 0;
  height: auto;
  min-height: calc(max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px);
  color: #153448;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.58) 0%,
    rgba(225, 236, 245, 0.82) 100%
  );
  backdrop-filter: blur(14px) saturate(1.15);
  -webkit-backdrop-filter: blur(14px) saturate(1.15);
  border-bottom: 1px solid rgba(21, 52, 72, 0.1);
  box-shadow: 0 4px 24px rgba(21, 52, 72, 0.06);
  padding: max(10px, env(safe-area-inset-top, 0px)) max(20px, env(safe-area-inset-right, 0px)) 12px
    max(20px, env(safe-area-inset-left, 0px));
  flex-wrap: wrap;
  gap: 0.5rem 0.35rem;
  align-items: center;
}

.mapshow .leftbar {
  position: fixed !important;
  top: var(--navbar-offset) !important;
  left: 0;
  width: min(400px, 100vw) !important;
  height: calc(100vh - var(--navbar-offset)) !important;
  max-height: calc(100dvh - var(--navbar-offset)) !important;
  z-index: 900;
}

.mapshow .navbar-left {
  margin-left: 0;
  margin-right: 0;
  gap: clamp(0.35rem, 1.5vw, 0.75rem);
  flex-wrap: wrap;
}

.mapshow .navbar-left img {
  max-height: clamp(40px, 8vw, 52px);
  width: auto;
  object-fit: contain;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.72);
  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.06);
}

.mapshow .navbar-search {
  margin-left: 0 !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem 0.35rem;
  flex: 1 1 auto;
  min-width: 0;
}

.mapshow .navbar-select,
.mapshow .navbar-select-well {
  width: auto;
  min-width: min(140px, 28vw);
  max-width: 100%;
  height: auto;
  min-height: 44px;
  line-height: 1.3;
  margin-left: 0;
  margin-right: 0;
  padding: 0.45rem 2rem 0.45rem 0.65rem;
  border-radius: 10px;
  font-size: clamp(0.8rem, 1.8vw, 0.9rem);
  font-weight: 600;
  text-align: left;
  color: #153448;
  background-color: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(30, 82, 120, 0.22);
  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04);
}

.mapshow .navbar-select-well {
  min-width: min(160px, 36vw);
  border-color: rgba(30, 82, 120, 0.25);
}

.mapshow .navbar-select option,
.mapshow .navbar-select-well option {
  color: #153448;
  background: #fff;
}

.mapshow .right-icon-btn,
.mapshow .right-icon-btn2 {
  padding: 0.5rem 0.95rem;
  font-size: clamp(0.78rem, 1.6vw, 0.875rem);
  font-weight: 600;
  border-radius: 10px;
  margin-right: 0 !important;
  margin-left: 0;
  border: 1px solid rgba(30, 82, 120, 0.18);
  color: #1e5278;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.05);
  transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.mapshow .right-icon-btn:hover,
.mapshow .right-icon-btn2:hover {
  opacity: 1;
  background: #fff;
  border-color: rgba(30, 82, 120, 0.28);
  box-shadow: 0 4px 14px rgba(21, 52, 72, 0.1);
}

.mapshow .right-icon-btn2 {
  color: #166534;
  border-color: rgba(22, 101, 52, 0.25);
  background: rgba(255, 255, 255, 0.9);
}

.mapshow .right-icon-btn2:hover {
  border-color: rgba(22, 101, 52, 0.35);
}

/* --- legacy map / modal (unchanged structure) --- */
.map-container {
  left: 0;
  top: 0;
}

.login-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(63, 61, 73, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.login-modal-content {
  background-color: rgba(43, 36, 83, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(8, 0, 255, 0.1);
  width: 350px;
  text-align: center;
}

.login-modal-content .close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  cursor: pointer;
}

.login-modal-content h2 {
  margin-bottom: 20px;
}

.login-modal-content input {
  width: 80%;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.login-modal-content button {
  padding: 10px 20px;
  border: none;
  background-color: #7429eb;
  color: white;
  cursor: pointer;
  border-radius: 4px;
  margin-top: 10px;
}

.login-modal-content button:hover {
  background-color: #53565a;
}

.alert {
  color: rgb(254, 0, 0);
  font-size: 1.3rem;
  margin-bottom: 15px;
}

.login-modal-content .close {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 24px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/mapshow.css"],"names":[],"mappings":"AAAA,kFAAkF;AAClF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,0EAA0E;EAC1E,cAAc;EACd,qEAAqE;EACrE;;;;;GAKC;AACH;;AAEA;EACE,6DAA6D;EAC7D,2DAA2D;EAC3D,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,4FAA4F;AAC5F;EACE,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,2DAA2D;EAC3D,6DAA6D;EAC7D,yDAAyD;EACzD,iHAAiH;EACjH,iDAAiD;EACjD,sDAAsD;AACxD;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,oDAAoD;EACpD,qEAAqE;EACrE;;;;;;;GAOC;AACH;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,iGAAiG;EACjG,cAAc;EACd;;;;GAIC;EACD,0CAA0C;EAC1C,kDAAkD;EAClD,8CAA8C;EAC9C,6CAA6C;EAC7C;6CAC2C;EAC3C,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,OAAO;EACP,mCAAmC;EACnC,qDAAqD;EACrD,0DAA0D;EAC1D,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,yCAAyC;EACzC,cAAc;EACd,qCAAqC;EACrC,4CAA4C;EAC5C,8EAA8E;AAChF;;AAEA;;EAEE,UAAU;EACV,gBAAgB;EAChB,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,qDAAqD;AACrD;EACE,OAAO;EACP,MAAM;AACR;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,kBAAkB;EAClB,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* Map route: same light sky gradient as home / profile (no global body theming) */\n.mapshow {\n  min-height: 100dvh;\n  min-height: 100vh;\n  box-sizing: border-box;\n  background: linear-gradient(210deg, #c5dff7 0%, #eef2f7 52%, #f4f7fa 100%);\n  color: #1c2d38;\n  /* Same offset token as landing/profile for content below fixed nav */\n  --navbar-offset: max(\n    7.25rem,\n    calc(\n      max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px + 2.25rem\n    )\n  );\n}\n\n.mapshow-inner {\n  /* No top/side inset — nav is full-bleed fixed like landing */\n  padding: 0 0 max(0.65rem, env(safe-area-inset-bottom, 0px));\n  box-sizing: border-box;\n  min-height: 100%;\n}\n\n/* Push map + leftbar below fixed navbar */\n.mapshow .map-layout {\n  padding-top: var(--navbar-offset);\n  box-sizing: border-box;\n}\n\n/* Map area: must match fixed .leftbar width (min(400px, 100vw)) so the map is not covered */\n.mapshow .map-layout__map-host {\n  box-sizing: border-box;\n  position: relative;\n  z-index: 1;\n  margin-top: 0;\n  margin-right: max(0.75rem, env(safe-area-inset-right, 0px));\n  margin-bottom: max(0.65rem, env(safe-area-inset-bottom, 0px));\n  margin-left: max(0.75rem, env(safe-area-inset-left, 0px));\n  width: calc(100vw - max(0.75rem, env(safe-area-inset-left, 0px)) - max(0.75rem, env(safe-area-inset-right, 0px)));\n  height: calc(100vh - var(--navbar-offset) - 1rem);\n  max-height: calc(100dvh - var(--navbar-offset) - 1rem);\n}\n\n.mapshow .map-layout--with-sidebar .map-layout__map-host {\n  --sidebar-w: min(400px, 100vw);\n  --map-gap: 0.5rem;\n  margin-left: calc(var(--sidebar-w) + var(--map-gap));\n  /* Map starts after sidebar + gap; only subtract right inset/margin */\n  width: clamp(\n    12rem,\n    calc(\n      100vw - var(--sidebar-w) - var(--map-gap) -\n        max(0.75rem, env(safe-area-inset-right, 0px))\n    ),\n    100vw\n  );\n}\n\n/* Map navbar — fixed top bar, match landing div.navbar behavior */\n.mapshow .navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  z-index: 1000;\n  border-radius: 0;\n  height: auto;\n  min-height: calc(max(10px, env(safe-area-inset-top, 0px)) + clamp(40px, 10vw, 56px) + 12px + 1px);\n  color: #153448;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0.58) 0%,\n    rgba(225, 236, 245, 0.82) 100%\n  );\n  backdrop-filter: blur(14px) saturate(1.15);\n  -webkit-backdrop-filter: blur(14px) saturate(1.15);\n  border-bottom: 1px solid rgba(21, 52, 72, 0.1);\n  box-shadow: 0 4px 24px rgba(21, 52, 72, 0.06);\n  padding: max(10px, env(safe-area-inset-top, 0px)) max(20px, env(safe-area-inset-right, 0px)) 12px\n    max(20px, env(safe-area-inset-left, 0px));\n  flex-wrap: wrap;\n  gap: 0.5rem 0.35rem;\n  align-items: center;\n}\n\n.mapshow .leftbar {\n  position: fixed !important;\n  top: var(--navbar-offset) !important;\n  left: 0;\n  width: min(400px, 100vw) !important;\n  height: calc(100vh - var(--navbar-offset)) !important;\n  max-height: calc(100dvh - var(--navbar-offset)) !important;\n  z-index: 900;\n}\n\n.mapshow .navbar-left {\n  margin-left: 0;\n  margin-right: 0;\n  gap: clamp(0.35rem, 1.5vw, 0.75rem);\n  flex-wrap: wrap;\n}\n\n.mapshow .navbar-left img {\n  max-height: clamp(40px, 8vw, 52px);\n  width: auto;\n  object-fit: contain;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.72);\n  box-shadow: 0 1px 3px rgba(21, 52, 72, 0.06);\n}\n\n.mapshow .navbar-search {\n  margin-left: 0 !important;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem 0.35rem;\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.mapshow .navbar-select,\n.mapshow .navbar-select-well {\n  width: auto;\n  min-width: min(140px, 28vw);\n  max-width: 100%;\n  height: auto;\n  min-height: 44px;\n  line-height: 1.3;\n  margin-left: 0;\n  margin-right: 0;\n  padding: 0.45rem 2rem 0.45rem 0.65rem;\n  border-radius: 10px;\n  font-size: clamp(0.8rem, 1.8vw, 0.9rem);\n  font-weight: 600;\n  text-align: left;\n  color: #153448;\n  background-color: rgba(255, 255, 255, 0.92);\n  border: 1px solid rgba(30, 82, 120, 0.22);\n  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.04);\n}\n\n.mapshow .navbar-select-well {\n  min-width: min(160px, 36vw);\n  border-color: rgba(30, 82, 120, 0.25);\n}\n\n.mapshow .navbar-select option,\n.mapshow .navbar-select-well option {\n  color: #153448;\n  background: #fff;\n}\n\n.mapshow .right-icon-btn,\n.mapshow .right-icon-btn2 {\n  padding: 0.5rem 0.95rem;\n  font-size: clamp(0.78rem, 1.6vw, 0.875rem);\n  font-weight: 600;\n  border-radius: 10px;\n  margin-right: 0 !important;\n  margin-left: 0;\n  border: 1px solid rgba(30, 82, 120, 0.18);\n  color: #1e5278;\n  background: rgba(255, 255, 255, 0.88);\n  box-shadow: 0 1px 2px rgba(21, 52, 72, 0.05);\n  transition: background 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;\n}\n\n.mapshow .right-icon-btn:hover,\n.mapshow .right-icon-btn2:hover {\n  opacity: 1;\n  background: #fff;\n  border-color: rgba(30, 82, 120, 0.28);\n  box-shadow: 0 4px 14px rgba(21, 52, 72, 0.1);\n}\n\n.mapshow .right-icon-btn2 {\n  color: #166534;\n  border-color: rgba(22, 101, 52, 0.25);\n  background: rgba(255, 255, 255, 0.9);\n}\n\n.mapshow .right-icon-btn2:hover {\n  border-color: rgba(22, 101, 52, 0.35);\n}\n\n/* --- legacy map / modal (unchanged structure) --- */\n.map-container {\n  left: 0;\n  top: 0;\n}\n\n.login-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(63, 61, 73, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.login-modal-content {\n  background-color: rgba(43, 36, 83, 0.9);\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(8, 0, 255, 0.1);\n  width: 350px;\n  text-align: center;\n}\n\n.login-modal-content .close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.login-modal-content h2 {\n  margin-bottom: 20px;\n}\n\n.login-modal-content input {\n  width: 80%;\n  padding: 10px;\n  margin-bottom: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.login-modal-content button {\n  padding: 10px 20px;\n  border: none;\n  background-color: #7429eb;\n  color: white;\n  cursor: pointer;\n  border-radius: 4px;\n  margin-top: 10px;\n}\n\n.login-modal-content button:hover {\n  background-color: #53565a;\n}\n\n.alert {\n  color: rgb(254, 0, 0);\n  font-size: 1.3rem;\n  margin-bottom: 15px;\n}\n\n.login-modal-content .close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  font-size: 24px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
